module.exports = __webpack_public_path__ + "static/img/gupiao.36588659.png";